import React, {useEffect, useRef, useState} from "react";
import {Tooltip} from '@mui/material';
import {arrowSxDefault, tooltipSxDefault} from "../Styles";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Td with dynamic content
 * @param String id: td identifier (optional)
 * @param String tableId: Identifier for the table (required)
 * @param JSX.Element children: Text or JSX element (required)
 * @param String classes: Add extra classNames for <td> (optional)
 * @param Boolean fixed: Fix the <td> (optional)
 * @param Integer left: If fixed, the left position for the <td> (optional)
 * @param String tooltip: If children have the class "text-ellipsis", this text is used as a tooltip in the <td> (optional)
 * @returns {JSX.Element}
 */
const CustomTd = ({id, tableId, children, classes, fixed = false, left = 0, tooltip = "",
                      tooltipSx = tooltipSxDefault,
                      arrowSx = arrowSxDefault}) => {
    const elementRef = useRef(null);
    const headerOffset = useRef(0);
    const originalLeft = useRef(0);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        if (!fixed) return;
        if (elementRef.current) {
            headerOffset.current = elementRef.current.offsetTop;
            originalLeft.current = elementRef.current.getBoundingClientRect().left;
        }

        const handleScroll = () => {
            let table = document.getElementById(`${tableId}`);

            if (elementRef.current) {
                if (table && table.scrollLeft > 0) {
                    elementRef.current.style.position = "sticky";
                    elementRef.current.style.left = left + "px";
                    elementRef.current.style.zIndex = "0";
                } else {
                    elementRef.current.style.removeProperty("position");
                    elementRef.current.style.removeProperty("left");
                    elementRef.current.style.removeProperty("zIndex");
                }
            }
        };

        let table = document.getElementById(`${tableId}`);
        if (table) table.addEventListener("scroll", handleScroll);

        return () => {
            if (table) table.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (elementRef.current) {
            const spanElement = elementRef.current.querySelector('.text-ellipsis');
            if (spanElement) {
                setIsTruncated(spanElement.scrollWidth > spanElement.clientWidth);
            }
        }
    }, [children]);

    return <td id={id} ref={elementRef} className={classes}> {(isTruncated && tooltip)
        ?
        <Tooltip title={tooltip} placement="top" componentsProps={{tooltip: {sx: tooltipSx}, arrow: {sx: arrowSx},}}>
            {children}
        </Tooltip>
        : children}
    </td>

}
export default CustomTd;
